import React, { useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { useChangeResponsible, useGetCustomer } from "../../hooks/useCrm";
import Loading from "../Loadings/LoadingTable";
const initvalue = {
  IdS0alesOpportunities: null,
  IdResponsible: null,
};
export const ChangeResponsibleModal = ({
  show,
  handleClose,

  idSalesOpportunities,
  userdata,
}) => {
  const [button] = useState(false);
  const [data, setDate] = useState(initvalue);
  const { data: customerresponsible } = useGetCustomer();

  const customerResponsible = customerresponsible?.data?.Colleague;
  const customerResponsibleOptions = customerResponsible?.map((res) => {
    return {
      value: res.IdUser,
      label: res.FirstName + " " + res.LastName,
    };
  });
  const {
    mutateAsync: ChangeResponsible,
    isLoading: ChangeResponsibleLoading,
  } = useChangeResponsible();
  const handleChangeResposible = async (changeid) => {
    await ChangeResponsible(changeid);
  };

  return (
    <BootstrapModal
      modaltitle="تغییر مسئول"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <>
        {!ChangeResponsibleLoading ? (
          <>
            <SimpleSelect1
              label={"تغییر مسئول پرونده"}
              res={customerResponsibleOptions}
              placeholder={
                userdata?.ResponsibleUser[0]?.FirstName +
                " " +
                userdata?.ResponsibleUser[0]?.LastName
              }
              onChange={(e) =>
                setDate({
                  ...data,
                  IdResponsible: e.value,
                  IdS0alesOpportunities: idSalesOpportunities,
                })
              }
            />
            <div className="d-flex w-100 justify-content-end mt-4">
              <Button
                small="70px"
                className="p-1 mx-2"
                bgColor="#50cd89"
                color="#fff"
                onclick={() => {
                  handleChangeResposible(data);
                  handleClose();
                }}
              >
                تایید
              </Button>
              <Button
                small="70px"
                className="p-1"
                bgColor="#f1416c"
                color="#fff"
              >
                لغو
              </Button>
            </div>
          </>
        ) : (
          <Loading />
        )}
      </>
    </BootstrapModal>
  );
};
